export default "__VITE_ASSET__Cr738T_T__"